import { useCallback, useState } from 'react';
import {
  enviarOrden,
  getImprimirOrden,
  validarReimpresionOrdenById,
} from '../../../services/Seo/Orden';

export const useOrdenAutomaticaPreview = () => {
  const [datosOrden, setDatosOrden] = useState();
  const [urlReporte, setUrlReporte] = useState();
  const [loading, setLoading] = useState(false);
  const [successCorreo, setSuccessCorreo] = useState('');

  const generarUrlReporte = async (orden) => {
    try {
      const response = await getImprimirOrden({
        numeroOrden: orden?.numeroOrdenSinFormato,
      });
      setUrlReporte(response);
    } catch (error) {
      console.error('Error generating report URL :>> ', error);
    }
  };

  const getOrdenData = useCallback(async (idOrden) => {
    setLoading(true);
    try {
      const response = await validarReimpresionOrdenById(idOrden);
      if (response?.orden) {
        setDatosOrden(response);
        await generarUrlReporte(response.orden);
      }
    } catch (error) {
      console.error('Error fetching orden :>> ', error);
    } finally {
      setLoading(false);
    }
  }, []);

  const enviarCorreo = async (correo) => {
    setLoading(true);
    setSuccessCorreo('');
    try {
      await enviarOrden({
        numeroOrden: datosOrden?.orden?.numeroOrdenSinFormato,
        correo: correo,
      });

      setSuccessCorreo('Orden enviada al correo: ' + correo);
    } catch (e) {
      console.error('Error sending order email :>> ', e);
    } finally {
      setLoading(false);
    }
  };

  return {
    datosOrden,
    enviarCorreo,
    getOrdenData,
    loading,
    setDatosOrden,
    successCorreo,
    urlReporte,
  };
};
